module.exports = __webpack_public_path__ + "static/media/spoonerism-task (15).ff62e2b1.mp3";